import styled from '@emotion/styled';

import _NewIcon from '@/assets/icons/icon_new.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const TimeWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    '& > i': {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);

export const NewIcon = styled.i(() =>
  mq({
    width: '30px',
    height: '15px',
    backgroundImage: `url(${_NewIcon})`,
    backgroundCover: 'contain',
    backgroundRepeat: 'no-repeat',
  }),
);

export const PublishedAt = styled.time(() =>
  mq({
    color: defaultTheme.text.time,
    fontSize: defaultTheme.font.size.s,
  }),
);
